export enum CutoutOrderSize {
  V = 'Visible Glass Size',
  C = 'Cutout Size',
}
